// https://vitepress.dev/guide/custom-theme

import type { Theme } from "vitepress";
import { defineAsyncComponent, h } from "vue";
// Footer (used in splashpage.md)
import AsideStack from "./footer/AsideStack.vue";
import FooterGrid from "./footer/FooterGrid.vue";
// Root layout
import Layout from "./layouts/Layout.vue";

// Demos (lazy-loaded)
const EasingDemo = defineAsyncComponent(() => import("./demos/EasingDemo.vue"));
const BezierControlPointsDemo = defineAsyncComponent(
  () => import("./demos/BezierControlPointsDemo.vue"),
);
const BernsteinBasisDemo = defineAsyncComponent(
  () => import("./demos/BernsteinBasisDemo.vue"),
);
const LinearVsBezierDemo = defineAsyncComponent(
  () => import("./demos/LinearVsBezierDemo.vue"),
);
const DitherDemo = defineAsyncComponent(() => import("./demos/DitherDemo.vue"));
const InkSplotchRD = defineAsyncComponent(
  () => import("./demos/InkSplotchRD.vue"),
);
const FileUploadDemo = defineAsyncComponent(
  () => import("./demos/file-upload/FileUploadDemo.vue"),
);
const FileUploadStateGallery = defineAsyncComponent(
  () => import("./demos/file-upload/FileUploadStateGallery.vue"),
);

// Features - Content (index/listing components)
import ArticlesIndex from "./features/content/ArticlesIndex.vue";
import DemosIndex from "./features/content/DemosIndex.vue";
import ProjectsIndex from "./features/content/ProjectsIndex.vue";
import TagPage from "./features/content/TagPage.vue";
import TagsIndex from "./features/content/TagsIndex.vue";
import BadgePill from "./primitives/BadgePill.vue";
import BorderedBox from "./primitives/BorderedBox.vue";
import Card from "./primitives/card/Card.vue";
import StatBlock from "./primitives/StatBlock.vue";
// Primitives (reusable UI components)
import TagList from "./primitives/TagList.vue";

import "./style.scss";

export default {
  Layout: () => {
    return h(Layout, null, {
      // https://vitepress.dev/guide/extending-default-theme#layout-slots
    });
  },
  enhanceApp({ app }) {
    // Components used in markdown files
    app.component("ArticlesIndex", ArticlesIndex);
    app.component("DemosIndex", DemosIndex);
    app.component("ProjectsIndex", ProjectsIndex);
    app.component("TagPage", TagPage);
    app.component("TagsIndex", TagsIndex);

    // Demo components (used in articles/demos)
    app.component("EasingDemo", EasingDemo);
    app.component("BezierControlPointsDemo", BezierControlPointsDemo);
    app.component("BernsteinBasisDemo", BernsteinBasisDemo);
    app.component("LinearVsBezierDemo", LinearVsBezierDemo);
    app.component("DitherDemo", DitherDemo);
    app.component("InkSplotchRD", InkSplotchRD);
    app.component("FileUploadDemo", FileUploadDemo);
    app.component("FileUploadStateGallery", FileUploadStateGallery);

    // Components used in splashpage.md (component showcase)
    app.component("TagList", TagList);
    app.component("BadgePill", BadgePill);
    app.component("BorderedBox", BorderedBox);
    app.component("StatBlock", StatBlock);
    app.component("Card", Card);
    app.component("AsideStack", AsideStack);
    app.component("FooterGrid", FooterGrid);
  },
} satisfies Theme;
